import { combineReducers } from 'redux';

const reducers = combineReducers({
});

export default reducers;
export type RootState = ReturnType<typeof reducers>;